import { createSelector } from 'reselect';
import { get, isEmpty } from 'lodash';
import { AI_STATES } from './constants';

/**
 * Direct selector to the ai survey builder state domain
 */
const selectAIDomain = (state) => get(state, 'AISurveyBuilder', {});

const makeSelectAIChatHistory = createSelector(
  selectAIDomain,
  (substate) => substate.history || [],
);

const makeSelectAIisFetching = createSelector(
  selectAIDomain,
  (substate) => substate.isFetching || false,
);

const makeSelectAIisError = createSelector(
  selectAIDomain,
  (substate) => !isEmpty(substate.error) || false,
);

const makeSelectAIisOpen = createSelector(
  selectAIDomain,
  (substate) => substate.isPanelOpen || false,
);

const makeSelectAiWebWorker = createSelector(
  selectAIDomain,
  (substate) => substate.worker,
);

const makeSelectAiStatus = createSelector(
  selectAIDomain,
  (substate) => substate.status || AI_STATES.IDLE,
);

const makeSelectStreamingMessage = createSelector(
  selectAIDomain,
  (substate) => substate.streamingMessage,
);

const makeSelectAiIsIdle = createSelector(
  makeSelectAiStatus,
  (status) => status === AI_STATES.IDLE,
);

const makeSelectAIUserPrompt = createSelector(selectAIDomain, (substate) => ({
  userPromptMessage: substate.userPromptMessage || undefined,
  userPromptKey: substate.userPromptKey || undefined,
}));
export {
  makeSelectAIChatHistory,
  makeSelectAIisFetching,
  makeSelectAIisError,
  makeSelectAIisOpen,
  makeSelectAiWebWorker,
  makeSelectAiStatus,
  makeSelectStreamingMessage,
  makeSelectAiIsIdle,
  makeSelectAIUserPrompt,
};
